import { styled } from '@mui/material/styles';
import React, { FC } from 'react';
import { IMappingFormSettingsResponse } from 'wisestep-api';

import ISubmissionSettingContext from '../../types/ISubmissionSettingContext';
import ISubmissionSettingsResponse from '../../types/ISubmissionSettingsResponse';
import ControlledTextArea from '../ControlledTextArea/ControlledTextArea';
import ControlledWsButtonGroup from '../ControlledWsButtonGroup/ControlledWsButtonGroup';
import { Item } from '../Item';
import { WsTypoColors, WsTypography, WsTypoVariants } from '../WsTypography';

const GridItem = styled(Item)(() => ({
  paddingTop: 0,
  paddingBottom: '10px',
}));

export interface IAssessmentInfo {
  showTitle?: boolean;
  submissionSetting?: ISubmissionSettingsResponse | ISubmissionSettingContext | null;
  purpose?: 'mapping' | 'submission';
  mappingFormSettings?: IMappingFormSettingsResponse;
}

const AssessmentInfo: FC<IAssessmentInfo> = ({
  showTitle = true,
  submissionSetting,
  purpose = 'submission',
  mappingFormSettings,
}) => (
  <>
    {purpose == 'submission' && (
      <>
        {showTitle && (
          <GridItem>
            <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.PRIMARY}>
              Assessment
            </WsTypography>
          </GridItem>
        )}
        {!submissionSetting?.interviewingAnywhereElse?.hidden && (
          <GridItem id="interviewingWithOthers">
            <ControlledWsButtonGroup
              name="interviewingWithOthers"
              inputTitle="Interviewing With Others"
              showMandatorySymbol={submissionSetting?.interviewingAnywhereElse?.required}
              buttonsList={['Yes', 'No']}
            />
          </GridItem>
        )}
        {!submissionSetting?.reasonForChange?.hidden && (
          <GridItem>
            <ControlledTextArea
              name="jobChangeReason"
              labelText="Reason for looking for a new job"
              showMandatorySymbol={submissionSetting?.reasonForChange?.required}
            />
          </GridItem>
        )}
        {!submissionSetting?.yourAssessment?.hidden && (
          <GridItem>
            <ControlledTextArea
              name="recruiterAssessment"
              labelText="Recruiters assessment Notes"
              showMandatorySymbol={submissionSetting?.yourAssessment?.required}
            />
          </GridItem>
        )}
      </>
    )}
    {purpose == 'mapping' && (
      <>
        {showTitle && (
          <GridItem>
            <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.PRIMARY}>
              Assessment
            </WsTypography>
          </GridItem>
        )}
        {mappingFormSettings?.interviewingWithOthers.show && (
          <GridItem id="interviewingWithOthers">
            <ControlledWsButtonGroup
              name="interviewingWithOthers"
              inputTitle="Interviewing With Others"
              showMandatorySymbol={mappingFormSettings?.interviewingWithOthers.mandatory}
              buttonsList={['Yes', 'No']}
            />
          </GridItem>
        )}
        {mappingFormSettings?.jobChangeReason.show && (
          <GridItem>
            <ControlledTextArea
              name="jobChangeReason"
              labelText="Reason for looking for a new job"
              showMandatorySymbol={mappingFormSettings?.jobChangeReason.mandatory}
            />
          </GridItem>
        )}
        {mappingFormSettings?.recruiterAssessment.show && (
          <GridItem>
            <ControlledTextArea
              name="recruiterAssessment"
              labelText="Recruiters assessment Notes"
              showMandatorySymbol={mappingFormSettings?.recruiterAssessment.mandatory}
            />
          </GridItem>
        )}
      </>
    )}
  </>
);

export default AssessmentInfo;
